import React, { useState, useEffect, useRef } from "react";
import classes from "./DakshPage.module.css";
import Daksh_logo from "../assets/Daksh_logo.png";

const Header = ({ onTechClick, onAccessClick }) => {
  const [showModal, setShowModal] = useState(false);

  const betaRef = useRef(null);

  const scrollToBeta = () => {
    betaRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCalendarOpen = () => {
    window.open(
      "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1EsNWvkXLWEC7fLwfd3A-uAfp6sByldbajvPT-0bY4YoXBybJ-kQi9Uh7eXRdZ1RLp9V1k9TeN",
      "_blank",
    );
  };

  return (
    <div className={classes.header}>
      <img src={Daksh_logo} alt="Daksh" className={classes.logoImg} />

      <div className={classes.nav}>
        <span
          className={classes.tech}
          onClick={onTechClick}
          style={{ cursor: "pointer" }}
        >
          TECHNOLOGY
        </span>
        <button
          className={classes.terminalBtn}
          onClick={handleCalendarOpen}
          // onClick={onAccessClick}
        >
          GET IN TOUCH
        </button>
      </div>
    </div>
  );
};

export default Header;
